module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-23.94577a59.png";